// extracted by mini-css-extract-plugin
export default {"area":"Textarea_area__Q8Npz"};